
import { Vue, Component, Prop } from "vue-property-decorator";
import EditForm from "@/views/Components/editForm.vue";
import SignUpInfo from "@/views/Components/signUpInfo.vue";

@Component({ components: { EditForm, SignUpInfo } })
export default class MemberInfo extends Vue {
  private flags: any = {
    isEdit: false,
    isLoading: false,
  };
  private userDatas: any = {};
  private activeName = "";
  private ces: any[] = [];
  @Prop({
    type: Array,
    default: {},
    required: true,
  })
  datas!: any[];
  created() {
    console.log("团员个人信息", this.datas);
    for (let i in this.datas) {
      this.datas[i].muid = String(this.datas[i].muid);
      this.GetSignMeetingUser(this.datas[i].muid);
    }

    this.activeName = this.datas[0].muid;
  }

  handleClick(tab: any, event: any) {
    for (let i in this.datas) {
      if (tab.name === this.datas[i].muid) {
        this.userDatas = this.ces[i];
      }
    }
    // console.log(tab.name, this.userDatas, this.datas);
  }
  /**
   * @description:个人数据
   */
  async GetSignMeetingUser(muid: number) {
    this.flags.isLoading = true;
    let params = {
      m: String(this.$route.query.m),
      muid,
    };
    let res = await this.$http.personalCenter.GetSignMeetingUser(params);
    // console.log("res", res);
    this.userDatas = {};

    if (res.Code === 1000) {
		res.ssl_muid = muid
      this.ces.push(res);
    }
    if (this.ces.length === this.datas.length) {
      this.userDatas.muid = muid;
      for (let i in this.datas) {
        if (this.activeName === this.datas[i].muid) {
          this.userDatas = this.ces[i];
        }
      }
      console.log("团员数据", this.ces);
    }
    this.flags.isLoading = false;
  }
  handleIsEdit(isEdit: any) {
    this.flags.isEdit = isEdit;
  }
}
